import { IInsuranceContract } from '@alberta/konexi-shared';
import { cloneDeep, groupBy } from 'lodash';
import { InsuranceContractDB } from 'src/app/common/repository/databases';
import { PrescriptionNodeValue } from 'src/app/shared/models/prescription/prescription-node-value.model';
import { PrescriptionRequestDto } from 'src/app/shared/models/prescription/prescription-request-dto.model';
import { QueryService } from 'src/app/shared/services/query/query.service';

import { PrescriptionPositionViewModel } from '../view-models/prescription-position-view-model';
import { PrescriptionChainHandler } from './prescription-chain-handler';

export class GroupByFlatChargeHandler extends PrescriptionChainHandler {
  constructor(private _queryService: QueryService) {
    super();
  }

  async handleRequest(prescriptionRequestDto: PrescriptionRequestDto, request: PrescriptionNodeValue) {
    for (let i = 0; i < prescriptionRequestDto.prescriptions.length; i++) {
      const currentPresciption = prescriptionRequestDto.prescriptions[i];
      let contracts = [];

      if (currentPresciption.positions.some(position => position.contractId)) {
        const contractIds = [
          ...new Set(
            currentPresciption.positions.filter(position => position.contractId).map(position => position.contractId)
          ),
        ];
        contracts = await this._queryService.search<IInsuranceContract>(
          { query: contractIds.map(id => `_id:${id}`).join(' ') },
          InsuranceContractDB,
          { isIn: true }
        );
      }

      const flatChargePositions = [];
      const flatChargeContracts = contracts.filter(
        contract => contract.flatChargeTextAllowed && contract.flatChargeText?.length
      );

      if (flatChargeContracts.length) {
        for (let j = 0; j < prescriptionRequestDto.prescriptions[i].positions.length; j++) {
          const correspondingContract = flatChargeContracts.find(
            contract => contract._id === prescriptionRequestDto.prescriptions[i].positions[j].contractId
          );
          if (correspondingContract) {
            prescriptionRequestDto.prescriptions[i].positions[j].name = correspondingContract.flatChargeText;
            flatChargePositions.push(prescriptionRequestDto.prescriptions[i].positions[j]);
            prescriptionRequestDto.prescriptions[i].positions.splice(j, 1);

            j -= 1;
          }
        }

        const articleLinesGroupedByFlatCharge = groupBy(flatChargePositions, position => position.name);
        const flatChargeTypes = Object.keys(articleLinesGroupedByFlatCharge);

        for (const flatChargeType of flatChargeTypes) {
          const additionalPrescription = cloneDeep(currentPresciption);
          additionalPrescription.positions = [
            { name: flatChargeType, isFlatCharge: true } as PrescriptionPositionViewModel,
          ];
          prescriptionRequestDto.prescriptions.push(additionalPrescription);
          i += 1;
        }
      }
    }
    prescriptionRequestDto.prescriptions.forEach((prescription, index) => {
      if (prescription.positions.length === 0) {
        prescriptionRequestDto.prescriptions.splice(index, 1);
      }
    });
    return this.next.handleRequest(prescriptionRequestDto, request);
  }
}
